import React, { useState, useEffect } from "react";
import { ToggleContainer, LeftButton, RightButton, Slider } from "./style";
import { useNavigate } from "react-router-dom";

const ExamTypeToggle = () => {
  const [active, setActive] = useState(0); // 0 for PTE, 1 for IELTS
  const navigate = useNavigate();

  useEffect(() => {
    // Check if there's a stored preference
    const examType = localStorage.getItem("exam-type");
    if (examType === "ielts") {
      setActive(1);
    } else {
      // Default to PTE
      setActive(0);
    }
  }, []);

  const handleClick = (value) => {
    if (active === value) {
      return;
    }
    
    // Update localStorage and state
    const newExamType = value === 1 ? "ielts" : "pte";
    localStorage.setItem("exam-type", newExamType);
    setActive(value);
    
    // Dispatch a custom event to notify other components about the exam type change
    const event = new CustomEvent("examTypeChanged", { detail: { examType: newExamType } });
    window.dispatchEvent(event);
    
    // Handle dashboard switching
    if (value === 1) {
      // Switch to IELTS dashboard
      navigate("/ielts-dashboard");
    } else {
      // Switch back to PTE dashboard
      navigate("/pte-dashboard");
    }
  };

  return (
    <ToggleContainer>
      <Slider isActive={active} />
      <LeftButton isActive={active === 0} onClick={() => handleClick(0)}>
        PTE Exam
      </LeftButton>
      <RightButton isActive={active === 1} onClick={() => handleClick(1)}>
        IELTS Exam
      </RightButton>
    </ToggleContainer>
  );
};

export default ExamTypeToggle;
